import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
  Button,
  Stack,
} from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import DistanceDisplay from "../../page/management/component/DistanceDisplay";
import { AuthContext } from "../../context/AuthContext";
import { reservationStoresForCity } from "../../storeVisibility";
export default function ReservationStep1({ categories, stores, nextStep }) {
  // We'll use a piece of state to keep track of the selected button
  const [selectedButton, setSelectedButton] = useState(null);
  const [filteredStores, setFilteredStores] = useState([]);
  const userContext = useContext(AuthContext);

  const theme = useTheme();
  const OrderButton = styled(Button)(({ theme }) => ({
    height: "5vh",
    fontSize: "medium",

    background: theme.gradients.primary,
    color: theme.palette.text.selected,
    border: theme.gradients.primary,
    borderRadius: "10px",
  }));
  const StyledContactButton = styled(Button)(({ theme }) => ({
    height: "5vh",
    fontSize: "medium",

    background: theme.palette.primary.main,
    color: theme.palette.text.blue,
    zIndex: 1,
    borderRadius: "10px",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: -1,
      borderRadius: "inherit",
      padding: "2.5px",
      background: theme.palette.selected,
      WebkitMask: ` 
linear-gradient(#fff 0 0) content-box, 
linear-gradient(#fff 0 0)`,
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
    },
  }));
  useEffect(() => {
    setFilteredStores(
      reservationStoresForCity(stores, selectedButton, userContext.pos)
    );
  }, [selectedButton, stores, userContext.pos]);

  const ContactButton = (description) => {
    const parts = description.split(/(IG:\S+)/);
    return parts.map((part, i) => {
      if (part.startsWith("IG:")) {
        const instagramHandle = part.slice(3); // Remove 'IG:'
        const instagramUrl = `https://www.instagram.com/${instagramHandle}`;

        return (
          <StyledContactButton
            key={`contact-${i}`}
            variant="contained"
            color="primary"
            onClick={() => {
              window.open(instagramUrl, "_blank");
            }}
          >
            問題聯繫
          </StyledContactButton>
        );
      }
      return null;
    });
  };

  const TagChip = ({ store }) => {
    const theme = useTheme();

    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, marginTop: 1 }}>
        {store.Tags?.map((tag, i) => (
          <Typography
            key={`TagChip-${i}`}
            border={2}
            color={theme.palette.text.blue}
            borderRadius={1}
            paddingX={1}
            borderColor={theme.palette.text.blue}
            sx={{
              whiteSpace: "nowrap", // Prevent text wrapping
              overflow: "hidden", // Hide overflow text
              textOverflow: "ellipsis", // Add ellipsis for overflow text
              flexShrink: 0, // Prevent flex items from shrinking
            }}
          >
            {` ${tag} `}
          </Typography>
        ))}
      </Box>
    );
  };
  return (
    <Box width="100%" height="100vh" bgcolor={theme.palette.background.default}>
      <Box
        margin={1}
        sx={{
          display: "flex",
          flexWrap: "wrap", // Allows buttons to wrap to the next line
          "& > *": {
            // Applies to all direct children (i.e., Button components)
            flexGrow: 1, // Allows buttons to grow and fill the container
            flexBasis: "calc(25% -2px)", // Sets a base width for each button, subtracting margin
          },
        }}
      >
        {(categories || []).map((label, index) => (
          <Button
            key={"categories" + index}
            // Set the variant based on the selected state
            variant={selectedButton === label ? "contained" : "contained"}
            // Set the click handler to update the selected button
            onClick={() => setSelectedButton(label)}
            sx={{
              maxWidth: "25%",
              margin: "1px",
              fontSize: "12pt",
              fontWeight: "bold",
              background:
                selectedButton === label
                  ? theme.palette.selected
                  : theme.palette.primary.main,

              borderRadius: 5,
              zIndex: 1,
              color:
                selectedButton === label
                  ? theme.palette.text.selected
                  : theme.palette.text.blue,
              "&:before": {
                content: '""',
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                zIndex: -1,
                borderRadius: "inherit",
                padding: "2.5px",
                background: theme.palette.selected,
                WebkitMask: ` 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0)`,
                WebkitMaskComposite: "xor",
                maskComposite: "exclude",
              },
              "&:focus": {
                backgroundColor: theme.palette.selected,
                color: theme.palette.text.selected,
              },
            }}
          >
            {label}
          </Button>
        ))}
      </Box>
      {filteredStores.map((store, index) => (
        <Card
          elevation={0}
          key={"card" + index}
          sx={{ marginBottom: 1, borderRadius: 0 }}
        >
          <React.Fragment key={"frag" + index}>
            <CardContent>
              <Stack
                direction={"row"}
                maxWidth={"100%"}
                justifyContent="space-between"
              >
                <Box flexDirection={"column"}>
                <Stack direction={'row'}>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    fontSize={"large"}
                    fontWeight={"bold"}
                  >
                    {store.Name}
                  </Typography>

                  <DistanceDisplay
                    lat1={userContext.pos?.lat}
                    lng1={userContext.pos?.lng}
                    lat2={store?.Latitude}
                    lng2={store?.Longitude}
                  ></DistanceDisplay></Stack>
                  <Stack direction={"column"}>
                    <React.Fragment>
                      <Typography
                        sx={{ display: "inline" }}
                        component="span"
                        variant="body2"
                        color={theme.palette.text.secondary}
                        fontSize={"medium"}
                      >
                        {store.Address}
                      </Typography>
                    </React.Fragment>
                  </Stack>
                  <Stack direction={"row"} spacing={1} marginTop={1}>
                    {" "}
                    <TagChip store={store}></TagChip>
                  </Stack>

                  {!store.OnlinePaymentAvailable ? (
                    <Chip
                      key={`onlinepay-${index}`}
                      label={`不支援線上支付`}
                      sx={{
                        backgroundColor: theme.palette.chip,
                        fontWeight: "bold",
                        justifySelf: "center",
                      }}
                    />
                  ) : null}
                </Box>
                <Stack
                  minWidth={"30%"}
                  direction={"column"}
                  width="calc(30% - 5px)"
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  spacing={1}
                >
                  <OrderButton
                    key={`OrderButton-${index}`}
                    background={theme.palette.primary.main}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const data = {
                        store: store,
                      };
                      nextStep(data);
                    }}
                  >
                    前往訂位
                  </OrderButton>
                  {ContactButton(store.Description)}
                </Stack>
              </Stack>
            </CardContent>
          </React.Fragment>
        </Card>
      ))}
    </Box>
  );
}
